import Enum from '../../utils/enum';

const TypingContext = new Enum(['GLOBAL', 'GROUP', 'ORGANIZATION'] as const, {
  valueFn: (x) => x.toLowerCase(),
});

export default TypingContext;
